import { animate, style, transition, trigger } from '@angular/animations';

/** Curva suave tipo iOS (sin rebote) */
const easeOutSoft = 'cubic-bezier(0.22, 1, 0.36, 1)';

/**
 * Transición entre rutas del shell (firmar ↔ verificar ↔ admin…).
 * Anima el contenedor al cambiar la clave de ruta.
 */
export const routeSoftAnimation = trigger('routeSoft', [
  transition('* <=> *', [
    style({ opacity: 0, transform: 'translateY(8px)' }),
    animate(
      `480ms ${easeOutSoft}`,
      style({ opacity: 1, transform: 'none' })
    )
  ])
]);

/**
 * Cambio de mecanismo / pestaña dentro del workspace.
 */
export const softViewAnimation = trigger('softView', [
  transition(':enter', [
    style({
      opacity: 0,
      transform: 'translateY(10px)'
    }),
    animate(
      `460ms ${easeOutSoft}`,
      style({
        opacity: 1,
        transform: 'none'
      })
    )
  ]),
  transition('* => *', [
    style({
      opacity: 0.45,
      transform: 'translateY(8px)'
    }),
    animate(
      `420ms ${easeOutSoft}`,
      style({
        opacity: 1,
        transform: 'none'
      })
    )
  ])
]);

/**
 * Paneles internos de modales (RSE, etc.).
 * Morph suave entre estados (preparing → waiting → signing…).
 */
export const modalPanelAnimation = trigger('modalPanel', [
  transition(':enter', [
    style({
      opacity: 0,
      transform: 'translateY(10px) scale(0.985)'
    }),
    animate(
      `560ms ${easeOutSoft}`,
      style({
        opacity: 1,
        transform: 'none'
      })
    )
  ]),
  transition('preparing => waiting', [
    style({ opacity: 0.55 }),
    animate(`480ms ${easeOutSoft}`, style({ opacity: 1 }))
  ]),
  transition('waiting => signing', [
    style({ opacity: 0.45, transform: 'translateY(6px)' }),
    animate(`460ms ${easeOutSoft}`, style({ opacity: 1, transform: 'none' }))
  ]),
  transition('signing => success', [
    style({ opacity: 0.4, transform: 'scale(0.98)' }),
    animate(`500ms ${easeOutSoft}`, style({ opacity: 1, transform: 'none' }))
  ]),
  transition('* => *', [
    style({
      opacity: 0,
      transform: 'translateY(6px)'
    }),
    animate(
      `420ms ${easeOutSoft}`,
      style({
        opacity: 1,
        transform: 'none'
      })
    )
  ])
]);
